import { customizationParser } from "./services/helpers/customization-helper";

// Base assets with branding-specific paths
const defaultAssets = {
  policeLine: "img/default/win-barrier.png",
  coinImage: "img/default/win-coin.png",
  musicLoop: "sounds/default/background-music-theme.ogg",
  fire: "img/default/winning-streak.png",
  playerRun: Array.from({ length: 24 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_side/Basketball_player_run_side_with_ball_${imageIndex}.png`;
  }),
  playerHurt: Array.from({ length: 31 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_hurt/Basketball_player_hurt_${imageIndex}.png`;
  }),
  playerRunBlackHair: Array.from({ length: 20 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_black_hair/Basketball_player_A_run_${imageIndex}.png`;
  }),
  playerRunWhiteHair: Array.from({ length: 20 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_run_light_hair/Basketball_player_B_run_${imageIndex}.png`;
  }),
  playerTackleImages: Array.from({ length: 20 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_slider/Basketball_player_A_block_${imageIndex}.png`;
  }),
  playerIdle: Array.from({ length: 24 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_idle/Basketball_player_idle_${imageIndex}.png`;
  }),
  playerWon: Array.from({ length: 35 }, (_, i) => {
    const imageIndex = i <= 9 ? `0${i}` : i;
    return `img/default/Football_player_jump/Basketball_player_win_${imageIndex}.png`;
  }),
};

const brandingAssets = {
  winner: {
    policeLine: "img/winner/win-barrier.png",
    coinImage: "img/winner/win-coin.png",
    musicLoop: "sounds/winner/background-music-theme.ogg",
  }
};


// Function to get branding assets based on the current branding
const getCurrentAssets = (branding = "default") => {
  return {
    ...defaultAssets,
    ...(brandingAssets[branding] || {}),
  };
};

const customization = customizationParser();

// Set the current branding somewhere in your app initialization
const currentBranding = customization?.branding || ""; // replace with actual branding logic

// Export assets based on the current branding
export const assets = getCurrentAssets(currentBranding);
